import { ApiPaths } from 'services/api/apiPaths';
import RedisApiAxiosInstance from '../../../services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';

export const createClusterRole = (data: { clusterRole: ClusterRole }) =>
  RedisApiAxiosInstance.post(ApiPaths.CLUSTER_ROLES, data);

export const updateClusterRole = (data: { clusterRole: ClusterRole }) =>
  RedisApiAxiosInstance.put(`${ApiPaths.CLUSTER_ROLES}/${data.clusterRole.id}`, data);
